import { render, staticRenderFns } from "./VolumetricWeight.vue?vue&type=template&id=5e97111f&"
import script from "./VolumetricWeight.vue?vue&type=script&lang=js&"
export * from "./VolumetricWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports